<template>
  <div class="aaaaa" >

    <!-- <div ref="search_d">
      <el-row type="flex" class="row-bg" justify="space-around">

        <el-form :inline="true" :model="queryInfo.condition" class="demo-form-inline">
          <el-form-item label="商家名称">
            <el-input v-model="queryInfo.condition.supplierName" placeholder="商家名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div> -->
    <div class="bbbbb" >
    <el-form  style="width: 500px; text-align: center" label-width="180px" class="demo-form-inline" >
      <el-form-item label="用户签到赠送积分" >
        <el-input  type="number" v-model="scoreConfig.signScore" placeholder="用户签到赠送积分"></el-input>
      </el-form-item>
      <el-form-item label="浏览商品10秒赠送积分">
        <el-input type="number" v-model="scoreConfig.browseScore" placeholder="用户签到赠送积分"></el-input>
      </el-form-item>
      <el-form-item label="首单赠送积分">
        <el-input type="number" v-model="scoreConfig.giveScore" placeholder="首单赠送积分"></el-input>
      </el-form-item>
      <el-form-item label="用户完善信息赠送积分">
        <el-input type="number" v-model="scoreConfig.improveInfoScore" placeholder="用户完善信息赠送积分"></el-input>
      </el-form-item>
      <el-row >
        <el-button type="primary" @click="saveConfig">保存</el-button>
      </el-row>
    </el-form>
<!--    <el-form :inline="true" class="demo-form-inline">-->
<!--      <el-form-item label="浏览商品10秒赠送积分">-->
<!--        <el-input v-model="scoreConfig.browseScore" placeholder="用户签到赠送积分"></el-input>-->
<!--      </el-form-item>-->

<!--    </el-form>-->
<!--    <el-form :inline="true" class="demo-form-inline">-->
<!--      <el-form-item label="首单赠送积分">-->
<!--        <el-input v-model="scoreConfig.giveScore" placeholder="首单赠送积分"></el-input>-->
<!--      </el-form-item>-->
<!--    </el-form>-->
<!--    <el-form :inline="true" class="demo-form-inline">-->
<!--      <el-form-item label="用户完善信息赠送积分">-->
<!--        <el-input v-model="scoreConfig.improveInfoScore" placeholder="用户完善信息赠送积分"></el-input>-->
<!--      </el-form-item>-->
<!--    </el-form>-->

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      dialogOrderItemVisible: false,
      orderInfo: '',
      orderItemData: '',
      activeName: 'first',
      orderProgressData: '',
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      formInline: {
        user: '',
        region: ''
      },
      scoreConfig: {}
    }
  },

  created () {
    this.getScoreConfig()
  },

  // mounted () {
  //   this.$nextTick(() => {
  //     // 获取定义ref属性 和 元素高度
  //     this.headerHeight = this.$refs.search_d.offsetHeight
  //     window.addEventListener('resize', this.getHeight())
  //   })
  // },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },

    // 获取数据
    getScoreConfig () {
      var that = this
      var data = {}

      that.$http.post('/merchantScoreConfig/queryOne', data).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200 && response.data.data != null) {

          that.scoreConfig = response.data.data
        }
      })
    },

    saveConfig () {
      var that = this
      that.$http.post('/merchantScoreConfig/saveScoreConfig', this.scoreConfig).then( (response)=> {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          this.getScoreConfig()
        }
      })
    }

  }
}
</script>

<style scoped></style>
